import { makeEnvironmentProviders } from '@angular/core';
import { provideEffects } from '@ngrx/effects';
import { provideState } from '@ngrx/store';

import { FlockRegistrationDeliveryService } from './services/flock-registration-delivery.service';
import { DeliveryEffects } from './store/effects/delivery.effects';
import * as deliveryReducers from './store/reducers/delivery.reducers';

export function provideDeliveryFeature() {
  return makeEnvironmentProviders([
    provideState('deliveryModule', deliveryReducers.reducer),
    provideEffects(DeliveryEffects),
    FlockRegistrationDeliveryService,
  ]);
}
